import { BE_VERSION } from '@/utilities/api/api-constant';
import API_TAGS from '@/utilities/api/api-tag.enum';
import baseApiSlice from '@/utilities/api/baseApiSlice';

const settingApi = baseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSetting: builder.query({
      query: () => ({ url: `/${BE_VERSION.LATEST}/setting` }),
      transformResponse: (data) => data.payload,
      providesTags: [API_TAGS.SETTING],
    }),
    saveSetting: builder.mutation({
      query: (body) => ({ url: `/${BE_VERSION.LATEST}/setting`, method: 'POST', body }),
      transformResponse: (data) => data.payload,
      invalidatesTags: [API_TAGS.SETTING],
    }),
  }),
});
const { useGetSettingQuery, useSaveSettingMutation } = settingApi;

export { useGetSettingQuery, useSaveSettingMutation, settingApi };
